var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C10.35 0 0 7.1875 0 15.8125C0 21.5625 5.75 26.7375 11.5 29.6125C11.5 35.65 5.75 37.6625 5.75 37.6625C13.8 37.6625 18.4 33.925 20.4125 31.625C21.275 31.625 22.1375 31.625 23 31.625C35.65 31.625 46 24.4375 46 15.8125C46 7.1875 35.65 0 23 0ZM14.375 20.125C12.65 20.125 11.5 18.975 11.5 17.25C11.5 15.525 12.65 14.375 14.375 14.375C16.1 14.375 17.25 15.525 17.25 17.25C17.25 18.975 16.1 20.125 14.375 20.125ZM23 20.125C21.275 20.125 20.125 18.975 20.125 17.25C20.125 15.525 21.275 14.375 23 14.375C24.725 14.375 25.875 15.525 25.875 17.25C25.875 18.975 24.725 20.125 23 20.125ZM31.625 20.125C29.9 20.125 28.75 18.975 28.75 17.25C28.75 15.525 29.9 14.375 31.625 14.375C33.35 14.375 34.5 15.525 34.5 17.25C34.5 18.975 33.35 20.125 31.625 20.125Z",
    fill: "#53D0A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSms);
export default __webpack_public_path__ + "static/media/text-sms.a6174e47691b3a0b18a094efaf44cb8c.svg";
export { ForwardRef as ReactComponent };